/**
 * dashboardUrls — shared URL helpers for embedding employee dashboards.
 * Extracted from EmployeeDashboardsTab.js (deleted 2026-07-23: the drill-down Dashboards view was
 * unreachable dead code; the overview panel in EmployeeDashboardPanel.js is the one live surface).
 *
 * Apps are served by the BACKEND (not the React dev server): prod = same-origin relative ("/app/..."
 * via nginx → :8000); dev = absolute http://localhost:8000 (no dev proxy exists). APP_BASE_URL below
 * captures exactly that. Each dashboard's embed URL is built from its registered `path` so the
 * root-vs-dashboard/ mismatch can't happen.
 */

// Where apps are actually served from. Prod: same origin (nginx proxies /app → :8000). Dev: the
// backend on :8000 directly, because the CRA dev server (:3000) does NOT proxy /app.
export const APP_BASE_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

// Pass the viewer's current theme as a URL param so the dashboard's first paint matches the site
// (also covers dev, where the app is a different origin and can't read the site's localStorage).
// `&v=` is a REVISION TOKEN derived from the dashboard's last_updated_at (kept WS-fresh by
// EmployeeDashboardContext). It changes ONLY when the agent logs a dashboard update via
// Employee_Dashboard_Update — so the iframe src changes (→ React reloads it) exactly when, and only
// when, the dashboard content actually changed. Without it the src is byte-identical across updates
// and the browser shows the cached page (the owner stares at a stale dashboard). Unrelated WS events
// (task/email) don't change last_updated_at → same `v` → no spurious reload.
// See agent_docs/ai_employees_dashboard_live_refresh_design.md.
export const dashboardEmbedUrl = (employeeId, dashboard, dark) => {
  const rev = dashboard.last_updated_at ? Date.parse(dashboard.last_updated_at) || 0 : 0;
  return `${APP_BASE_URL}/app/${employeeId}/${dashboard.path}/?cc_theme=${dark ? 'dark' : 'light'}&v=${rev}`;
};

// Clean standalone URL for the "open full page" control — no theme/revision params (a full-page
// visit paints from the board's own theme bootstrap, and a fresh fetch is fine there).
export const dashboardFullPageUrl = (employeeId, dashboard) =>
  `${APP_BASE_URL}/app/${employeeId}/${dashboard.path}/`;
